import { Typography } from "@mui/material";

const DashboardPanel = () => <Typography sx={{ color: "text.secondary" }}>TODO: Dashboard settings.</Typography>;

export default DashboardPanel;
